import React, { Suspense, useState } from 'react';
import { ReportingFilterBar } from '../../ui/components/reporting';
import { ReportingFilters } from '../../utils/types/reporting/reporting_types';
import { ReportingTabs } from './ReportingTabs';

const OverviewTab = React.lazy(() => import('./tabs/OverviewTab'));
const RecruitmentFunnelTab = React.lazy(() => import('./tabs/RecruitmentFunnelTab'));
const JobPerformanceTab = React.lazy(() => import('./tabs/JobPerformanceTab'));
const CandidateInsightsTab = React.lazy(() => import('./tabs/CandidateInsightsTab'));
const AssessmentAnalyticsTab = React.lazy(() => import('./tabs/AssessmentAnalyticsTab'));
const HiringOutcomesTab = React.lazy(() => import('./tabs/HiringOutcomesTab'));
const ExportsTab = React.lazy(() => import('./tabs/ExportsTab'));

const DEPARTMENTS = ['Engineering', 'Product', 'Sales', 'Marketing', 'HR'];
const JOB_TITLES: string[] = [];

const getDefaultDateRange = (): ReportingFilters['dateRange'] => {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 30);
  return { startDate, endDate };
};

const DEFAULT_FILTERS: ReportingFilters = {
  dateRange: getDefaultDateRange(),
  departments: [],
  jobTitles: [],
  locations: [],
};

const TabContentSkeleton = () => (
  <div className='space-y-4'>
    { Array.from({ length: 3 }).map((_, idx) => (
      <div key={idx} className='h-32 w-full animate-pulse rounded-xl bg-gray-100' />
    )) }
  </div>
);

export const ReportingPage = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [filters, setFilters] = useState<ReportingFilters>(DEFAULT_FILTERS);

  return (
    <div className='flex h-full min-h-screen flex-col bg-gray-50'>
      <div className='flex items-center justify-between border-b border-gray-100 bg-white px-6 py-4'>
        <div>
          <h1 className='text-2xl font-semibold text-gray-900'>Reporting</h1>
          <p className='mt-0.5 text-sm text-gray-500'>HierTalent recruitment analytics</p>
        </div>
      </div>

      <ReportingFilterBar
          filters={filters}
          onChange={setFilters}
          departments={DEPARTMENTS}
          jobTitles={JOB_TITLES}
      />

      <ReportingTabs activeTab={activeTab} onChange={setActiveTab} />

      <div className='flex-1 overflow-auto p-6'>
        <Suspense fallback={<TabContentSkeleton />}>
          { activeTab === 'overview' && <OverviewTab filters={filters} /> }
          { activeTab === 'recruitment_funnel' && <RecruitmentFunnelTab filters={filters} /> }
          { activeTab === 'job_performance' && <JobPerformanceTab filters={filters} /> }
          { activeTab === 'candidate_insights' && <CandidateInsightsTab filters={filters} /> }
          { activeTab === 'assessment_analytics' && <AssessmentAnalyticsTab filters={filters} /> }
          { activeTab === 'hiring_outcomes' && <HiringOutcomesTab filters={filters} /> }
          { activeTab === 'exports' && <ExportsTab filters={filters} /> }
        </Suspense>
      </div>
    </div>
  );
};
